import { createStyles } from "@mantine/emotion";

export const useStylesH1 = createStyles((theme) => {
  return {
    h1: {
      fontSize: theme.spacing.h1.fontSize,
      fontWeight: "400",
      marginTop: theme.spacing.h1.marginTop,
      fontFamily: theme.headings.fontFamily.secondary,
    },
  };
});
